import React from 'react';

import classes from './MapLayers.module.scss';
import { IPickedLayer, LayersTypes } from './MapLayers.model';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import MIcon from 'views/MIcon/MIcon';
import MapLayersOptions from './MapLayersOptions/MapLayersOptions';
import MapLayersLegends from './MapLayersLegends/MapLayersLegends';
import { ConnectorPowerLabel, ConnectorStatus } from 'utils/enums/chargingType';
import { useTranslation } from 'react-i18next';

type Props = {
  onEnterMapLayer: () => void;
  onLeaveMapLayer: () => void;
  onClickLayer: (layer: LayersTypes | null) => void;
  showMapLayersOption: boolean;
  showLayerType: LayersTypes | null;
  pickedLayer: IPickedLayer | null;
  darkMode: boolean;
  layerTypeOptions?: LayersTypes[];
  selectedPowerType?: ConnectorPowerLabel[];
  onSelectPowerType?: (powerType: ConnectorPowerLabel) => void;
  connectorStatus?: ConnectorStatus;
  onConnectorStatusChange?: (status: ConnectorStatus) => void;
};

const MapLayersView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();
  
  return (
    <div className={classes['container']}>
      <div onMouseEnter={props.onEnterMapLayer} onMouseLeave={props.onLeaveMapLayer} className={classes['square']}>
        {!props.pickedLayer ? (
          <div className={classes['img']}></div>
        ) : (
          <div>
            <MIcon className={`${classes['icon']} ${classes[`icon--${props.pickedLayer.name}`]}`} name={props.pickedLayer.icon}></MIcon>
          </div>
        )}
        <div className={classes['title']}>{props.pickedLayer?.name || t('components.mapLayers.options.layers')}</div>
      </div>
      <CSSTransition
        in={props.showMapLayersOption}
        timeout={400}
        classNames={{
          enterActive: classes['layerOptions--open'],
          enterDone: classNames(props.showMapLayersOption ? classes['layerOptions--open'] : ''),
        }}
      >
        <div
          className={classNames(classes['layerOptions'], {
            [classes['layerOptions--open']]: props.showMapLayersOption,
          })}
        >
          <MapLayersOptions
            onEnterMapLayer={props.onEnterMapLayer}
            onLeaveMapLayer={props.onLeaveMapLayer}
            onClickLayer={props.onClickLayer}
            pickedLayer={props.pickedLayer}
            layerTypeOptions={props.layerTypeOptions}
          ></MapLayersOptions>
        </div>
      </CSSTransition>

      {props.showLayerType === LayersTypes.EV ? (
        <MapLayersLegends
          selectedPowerType={props.selectedPowerType}
          onSelectPowerType={props.onSelectPowerType}
          connectorStatus={props.connectorStatus}
          onConnectorStatusChange={props.onConnectorStatusChange}
        ></MapLayersLegends>
      ) : null}
    </div>
  );
};

MapLayersView.displayName = 'MapLayersView';
MapLayersView.defaultProps = {};

export default MapLayersView;
